module.exports = __webpack_public_path__ + "static/media/SBDLibrary.69507683.svg";